import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=a1d4aa4e&scoped=true"
import script from "./pintuan.vue?vue&type=script&lang=js"
export * from "./pintuan.vue?vue&type=script&lang=js"
import style0 from "./pintuan.vue?vue&type=style&index=0&id=a1d4aa4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d4aa4e",
  null
  
)

export default component.exports